import { AutogenModelLocationLookupMulticompany, AutogenRowLocationLookupMulticompany } from "./autogen/AutogenModelLocationLookupMulticompany";

export class ModelLocationLookupMulticompany extends AutogenModelLocationLookupMulticompany<RowLocationLookupMulticompany> {
	constructor() {
		super(RowLocationLookupMulticompany);
	}
}

export class RowLocationLookupMulticompany extends AutogenRowLocationLookupMulticompany {
}